var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c(
        "div",
        { staticClass: "search-term" },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchInfo }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "店铺名称" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "搜索条件" },
                      model: {
                        value: _vm.searchInfo.sellerId,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "sellerId", $$v)
                        },
                        expression: "searchInfo.sellerId"
                      }
                    },
                    _vm._l(_vm.sellerOptions, function(item) {
                      return _c("el-option", {
                        key: item.sellerId,
                        attrs: { label: item.sellerName, value: item.sellerId }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.goodsName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "goodsName", $$v)
                      },
                      expression: "searchInfo.goodsName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "spu编号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.spuNo,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "spuNo", $$v)
                      },
                      expression: "searchInfo.spuNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品条码" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.goodsNo,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "goodsNo", $$v)
                      },
                      expression: "searchInfo.goodsNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置")
                  ])
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onGoodsIn }
                    },
                    [_vm._v("商品入库")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticClass: "online-shop-stock-table",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "tooltip-effect": "dark",
            height: "calc(100vh - 28rem)"
          },
          on: { "selection-change": _vm.handleSelChange }
        },
        [
          _c("el-table-column", {
            attrs: { label: "店铺名称", prop: "sellerId" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("getSellerName")(scope.row.sellerId)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "", width: "150", align: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-image", {
                      staticClass: "goods-logo",
                      attrs: {
                        src: scope.row.goodsImg,
                        fit: "contain",
                        "preview-src-list": [scope.row.goodsImg]
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "商品信息", width: "400" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "table-goods-info" }, [
                      _c("div", { staticClass: "bairun-table-goods-name" }, [
                        _vm._v(_vm._s(scope.row.goodsName))
                      ]),
                      _c("div", [
                        _vm._v(
                          _vm._s(scope.row.goodsSpecification) +
                            "/" +
                            _vm._s(scope.row.goodsUnit)
                        )
                      ]),
                      _c("div", [_vm._v(_vm._s(scope.row.spuNo))])
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "库存", prop: "goodsStock" }
          }),
          _c("el-table-column", {
            attrs: { label: "销售单价", prop: "goodsPrice" }
          }),
          _c("el-table-column", {
            attrs: { label: "最新成本单价", prop: "goodsLatestCost" }
          }),
          _c("el-table-column", {
            attrs: { label: "类目", prop: "categoryName" }
          }),
          _c("el-table-column", {
            attrs: { label: "创建时间", prop: "CreatedAt", width: "160px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.CreatedAt)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "250" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onView(scope.row)
                          }
                        }
                      },
                      [_vm._v("库存明细")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onUpdateGoodsPrice(scope.row)
                          }
                        }
                      },
                      [_vm._v("销售价")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.dialogVisible,
            title: _vm.exportShow ? "导出" : "变更销售价"
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-position": "right"
              }
            },
            [
              !_vm.exportShow
                ? _c(
                    "el-form-item",
                    { attrs: { label: "销售价:", prop: "goodsPrice" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.formData.goodsPrice,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "goodsPrice", $$v)
                          },
                          expression: "formData.goodsPrice"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.exportShow
                ? _c(
                    "el-form-item",
                    { attrs: { label: "油站名称:", prop: "sellerId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            filterable: "",
                            clearable: "",
                            placeholder: "请选择"
                          },
                          model: {
                            value: _vm.formData.sellerId,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "sellerId", $$v)
                            },
                            expression: "formData.sellerId"
                          }
                        },
                        _vm._l(_vm.sellerOptions, function(item) {
                          return _c("el-option", {
                            key: item.sellerId,
                            attrs: {
                              label: item.sellerName,
                              value: item.sellerId
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.enterDialog } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }